import { render, staticRenderFns } from "./ApiWeb.vue?vue&type=template&id=575fa8ca&scoped=true&"
var script = {}
import style0 from "./ApiWeb.vue?vue&type=style&index=0&id=575fa8ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575fa8ca",
  null
  
)

export default component.exports